<template>
  <div class="logins-wrapper">
    <div class="wrapper">
      <p class="logo_png"><img src="../../../static/images/logo.png" alt=""></p>
      <div class="box right">
        <div class="name">
          <input placeholder="手机号" type="text" name="user_name" id="tel" v-model='user_name' @keyup='checkIfCanLogin'>
        </div>
        <div class="pass">
          <input placeholder="验证码" type="password" name="password" id="pass" v-model='user_psd' @keyup='checkIfCanLogin'
                 :class="{'error_msg': error}">
          <button class="getcode" :disabled="isDisabled" @click="getCode">{{codeText}}</button>
        </div>
        <div class="r-bot">
          <button class="login" id="login" :disabled='disabledFlag' @click='login' :class="{disabled:disabledFlag}">登录
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        user_name: '',
        user_psd: '',
        error: false,
        disabledFlag: true,
        applets: this.$route.query.applets,
        isDisabled: false,
        codeText: '获取验证码'
      }
    },
    mounted () {
    },
    methods: {
      // 检测是否可登录
      checkIfCanLogin () {
        if ($('#tel').val().length > 0 && $('#pass').val().length > 0) {
          this.disabledFlag = false
        } else {
          this.disabledFlag = true
        }
      },
      getCode () {
        if (!this.isDisabled) {
          //获取验证码倒计时
          this.isDisabled = true
          let time = 60
          let timer = setInterval(() => {
            time--
            this.codeText = time + 's后重新发送'
            if (time <= 0) {
              this.codeText = '获取验证码'
              this.isDisabled = false
              clearInterval(timer)
            }
          }, 1000)
        }
      },
      login () {
        this.$api.LOGIN({
          username: this.user_name,
          password: this.user_psd
        }).then(res => {
          if (res.code == 0) {
            var ticketObj = {
              'offcn-ticket': res.data.ticket,
              ticket_source: res.data.ticket_source,
              sso_id: res.data.sso_user_id,
              name: res.data.user_info.name
            }
            console.log('55555555555'+this.ticketObj)
            window.localStorage.setItem('ticketObj', JSON.stringify(ticketObj))
            this.$router.push({path: 'index'})
          } else {
            this.error = true
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .logins-wrapper {
    height: 100%;
    background: #ffffff;
    .wrapper {
      padding: 60px;
      height: 100%;
      background: url(./static/images/background.png) no-repeat top center;
      background-size: cover;
      .logo_png {
        width: 164px;
        height: 164px;
        margin: 0 auto;
        margin-top: 48px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .box {
    margin-top: 140px;
    .name, .pass {
      position: relative;
      display: flex;
      align-items: center;
      input {
        width: 100%;
        height: 90px;
        outline: none;
        font-size: 28px;
        position: relative;
        border: none;
        border-bottom: 1px solid #cccccc;
      }
      .getcode {
        position: absolute;
        right: 0;
        color: #333;
        font-size: 24px;
        display: block;
        background: none;
        border: none;
      }

    }
    .pass {
      margin-top: 15px;
    }
    .r-bot {
      margin-top: 60px;
      .login {
        width: 100%;
        height: 100px;
        border: none;
        color: #ffffff;
        font-size: 36px;
        background: #e60012;
        border-radius: 10px;
        &.disabled {
          background: #e89692;
        }
      }
    }
    .error_msg {
      color: #e60012;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/index/logins.vue